import { Text, VStack } from '@chakra-ui/react';
import React, { useState } from 'react';
import ContractsTable from '../../ContractsTable';

import TabButtons from '@/components/atoms/TabButtons';
import ActiveContract from './ActiveContract';

type TAB_OPTIONS = 'active' | 'all';

type Props = {
  organizationId: string;
};

const OrganizationContractsTab = ({ organizationId }: Props) => {
  const [activeTab, setActiveTab] = useState<TAB_OPTIONS>('active');

  const onTabClick = (tab: TAB_OPTIONS) => {
    setActiveTab(tab);
  };

  return (
    <VStack flex={1} width={'100%'} paddingTop={'30px'}>
      <Text variant={'loraMediumTitle'}>Contracts</Text>
      <VStack marginTop={'15px'}>
        <TabButtons
          options={[
            {
              onClick: () => onTabClick('active'),
              labelValue: 'active',
              labelDisplay: 'Active',
            },
            {
              onClick: () => onTabClick('all'),
              labelValue: 'all',
              labelDisplay: 'All',
            },
          ]}
          selectedOptionValue={activeTab}
        />
      </VStack>
      {activeTab === 'active' && <ActiveContract organizationId={organizationId} />}
      {activeTab === 'all' && <ContractsTable organizationId={organizationId} />}
    </VStack>
  );
};

export default OrganizationContractsTab;
